import './styles/DatePeriodChip.scss';

import { Chip } from '@mui/material';

import { formatToDateWithoutTime, formatToTime } from 'utils/dates';

interface Props {
  start: Date;
  end: Date;
  type: 'STARTDATE-ENDDATE' | 'DATE/STARTTIME-ENDTIME';
}

export const DatePeriodChip = ({ start, end, type }: Props) => {
  switch (type) {
    case 'STARTDATE-ENDDATE':
      return <Chip label={`${formatToDateWithoutTime(start)} - ${formatToDateWithoutTime(end)}`} />;
    case 'DATE/STARTTIME-ENDTIME':
      return (
        <Chip
          label={`${formatToDateWithoutTime(start)} / ${formatToTime(start)}-${formatToTime(end)}`}
        />
      );
  }
};
